export default __webpack_public_path__ + "static/media/add5.9e9a7aac.jpg";